export const Register=()=>{
    return(
        <div>Register page</div>
    )
}